import { AfterContentInit, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

import { UsuarioAutorizacoes } from 'src/app/models/usuario.autorizacoes.model';
import { AreaTecnicaService } from 'src/app/pages/cadastros/areatecnica/areatecnica.service';
import { UsuarioService } from 'src/app/services/usuario.service';
import { AreaTecnica } from './areatecnica.model';


@Component({
  templateUrl: './areatecnica.component.html'
})
export class AreaTecnicaComponent implements OnInit, AfterContentInit {

  public cadastrados: AreaTecnica[] = [];
  public form: FormGroup = null;

  public isEditing = false;
  public isProcessing = false;
  public isFiltered = false;
  public isLoading = false;

  public voids: string[] = [];
  public maxRowsVoids = 7;

  autorizacoes: UsuarioAutorizacoes = null;

  constructor(
    private areatecnicaService: AreaTecnicaService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private usuarioService: UsuarioService
  ) { }

  ngAfterContentInit(): void {
    this.autorizacoes = this.usuarioService.getAutorizacoesJanelaPorRota('areatecnica');
  }

  ngOnInit() {
    this.list();
    this.resetForm(); // instancia o formulário utilizado (formGroup)
  }

  private list() {
    this.isLoading = true;
    this.areatecnicaService.list().subscribe(response => {
      this.cadastrados = response;
      this.isLoading = false;
      this.setVoids();
    });
  }


  public resetForm(): void {
    this.form = new FormGroup(
      {
        id: new FormControl(0),
        nome: new FormControl('', Validators.required),
      }
    );
  }

  public reset(): void {
    this.isEditing = false;
    this.isProcessing = false;
    this.isLoading = false;
    this.resetForm();
  }

  public read(id: number): void {

    this.reset();
    this.isProcessing = true;

    this.areatecnicaService.read(id).subscribe(

      (areaTecnica: AreaTecnica) => {
        this.form.get('id').setValue(areaTecnica.id);
        this.form.get('nome').setValue(areaTecnica.nome);
        this.isEditing = true;
        this.isProcessing = false;
      },
      (error: any) => {
        this.showError(error);
      },
    );
  }

  public submit(): void {

    this.isProcessing = true;

    if (this.form.get('id').value === 0) {
      this.areatecnicaService.isUniqueNomeAreaTecnica(this.form.get('nome').value).subscribe(

        (isUniqueNomeareatecnica: boolean) => {

          if (isUniqueNomeareatecnica) {
            this.save();
          } else {
            this.form.get('nome').setErrors({ isNotUniqueNomeAreaTecnica: true });
            this.isProcessing = false;
          }
        },
        (error: any) => { this.showError(error); }
      );
    } else {
      this.save();
    }

  }


  public save() {

    this.areatecnicaService.create(this.form.value).subscribe(

      (response: any) => {
        this.toastr.success(response.message);
        this.reset();
        this.list();
      },
      (error: any) => {
        this.showError(error);
      }
    );

  }

  public setVoids(): void {
    this.voids = [];
    if (this.cadastrados.length < this.maxRowsVoids) {
      for (let i = this.cadastrados.length; i < this.maxRowsVoids; i++) { this.voids.push(''); }
    }
  }

  public showModalSm(modal: any) {
    this.modalService.open(modal, { windowClass: 'smModal', backdrop: 'static'  });
  }

  public delete(id: number, c: any): void {

    this.isProcessing = true;
    c('Close click');

    this.areatecnicaService.delete(id).subscribe(

      (response: any) => {
        this.toastr.success(response.message);
        this.reset();
        this.list();
      },
      (error: any) => {
        this.showError(error);
      }
    );
  }

  public showError(error: any) {

    // this.form.get('codigo').setErrors({ hasError: true });

    if (error.error.errors) {
      this.toastr.error(error.error.errors[0].message);
    } else {
      this.toastr.error('Ocorreu um erro no servidor');
    }

    this.isProcessing = false;
  }

  public clearValor() {
    this.form.get('valor').setValue(null);
  }

}
